<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Reimposta password</h1>
      </div>
      <p class="editor-lead">Inserisci una nuova password.</p>
      <p class="editor-note">Lunghezza minima 8 caratteri. Richiesta almeno una lettera maiuscola e un carattere speciale !#$%^&amp;*(),.?":|&gt;</p>
    </header>

    <form class="editor-form" [formGroup]="newPswForm">
      <section class="editor-panel">
        <h2>Nuova password</h2>
        <div class="field-stack">
          <div class="field-block">
            <label for="password">Password<sup>*</sup></label>
            <div class="password-field">
              <input id="password" class="field" [type]="type1" formControlName="password" autocomplete="new-password"
                (input)="checkPsw()"
                [class.is-invalid]="newPswForm.get('password')?.invalid && (newPswForm.get('password')?.touched || newPswForm.get('password')?.dirty)">
              <button class="password-toggle" type="button" (click)="seePassword('password')"
                [attr.aria-label]="toggled1 ? 'Mostra password' : 'Nascondi password'">
                <i class="bi" [class.bi-eye]="toggled1" [class.bi-eye-slash]="!toggled1" aria-hidden="true"></i>
              </button>
            </div>
            @if (errorMessage && !validPassword) {
              <p class="field-error">La password inserita non è valida.</p>
            }
          </div>

          <div class="field-block">
            <label for="passwordRepeat">Ripeti password<sup>*</sup></label>
            <div class="password-field">
              <input id="passwordRepeat" class="field" [type]="type2" formControlName="passwordRepeat"
                autocomplete="new-password" (input)="checkPsw()"
                [class.is-invalid]="newPswForm.get('passwordRepeat')?.invalid && (newPswForm.get('passwordRepeat')?.touched || newPswForm.get('passwordRepeat')?.dirty)">
              <button class="password-toggle" type="button" (click)="seePassword('passwordRepeat')"
                [attr.aria-label]="toggled2 ? 'Mostra conferma password' : 'Nascondi conferma password'">
                <i class="bi" [class.bi-eye]="toggled2" [class.bi-eye-slash]="!toggled2" aria-hidden="true"></i>
              </button>
            </div>
            @if (errorMessage && !equalPassword) {
              <p class="field-error">Le password inserite non combaciano.</p>
            }
          </div>
        </div>
      </section>

      <div class="editor-actions">
        <button class="editor-save" type="button" (click)="send()" [disabled]="newPswForm.invalid">
          Reimposta
        </button>
      </div>
    </form>
  </div>
</div>
